import EtablissementDateCreation from '@/generated/controls/etablissement/EtablissementDateCreation.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementDateCreation
})
